import DashboardSettings from './container';

export default DashboardSettings;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/index.js